import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ConfirmDialog, Typography, useToast } from '@pocketlaw/tetris';
import { useRemoveEsigningRecipient } from 'app/domains/esigning/hooks/useRemoveEsigningRecipient';
export function ConfirmRemoveDialog(props) {
    const { recipient, onClose } = props;
    const { id, name } = recipient;
    const { addToast } = useToast();
    const [removeRecipient, { loading }] = useRemoveEsigningRecipient();
    const heading = t({
        comment: 'Remove signing party confirm dialog - title',
        message: 'Remove party',
    });
    const confirm = t({
        comment: 'Remove signing party confirm dialog - confirm button label',
        message: 'Remove',
    });
    const cancel = t({
        comment: 'Remove signing party confirm dialog - cancel button label',
        message: 'Cancel',
    });
    const handleConfirm = () => {
        removeRecipient({
            variables: { input: { id } },
            onSuccess: () => {
                onClose();
            },
            onError: () => {
                addToast({
                    appearance: 'danger',
                    title: t({
                        message: 'Could not remove eSigning party',
                        comment: 'Error title for removing signing party',
                    }),
                    message: t({
                        message: 'Something went wrong when removing the eSigning party, please try again',
                        comment: 'Error title for removing signing party',
                    }),
                });
            },
        });
    };
    return (<ConfirmDialog size="sm" appearance="danger" loading={loading} title={heading} confirm={confirm} cancel={cancel} onConfirm={handleConfirm} onCancel={onClose}>
      <Typography>
        <Trans comment="Remove signing party confirm dialog - dialog message">
          Are you sure you want to remove <b>{name}</b>?
        </Trans>
      </Typography>
    </ConfirmDialog>);
}
